import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper-chedules d-flex a-i-center" }
const _hoisted_2 = ["tabindex", "input-value", "name", "checked"]
const _hoisted_3 = { class: "text-raleway-13 ml-1" }

import { ShedulesDetails } from "@/store/modules/Schedules/type";
import { toRefs, ref, watch } from "vue";

import { ChedulesDetails } from "@/store/modules/accountDetails/type";
import { useField } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBoxComponent',
  props: {
    day: {},
    i: {},
    shedules: {},
    values: {},
    tabindex: {}
  },
  setup(__props: any) {

const props = __props;


const data = toRefs(props);

const { value, resetField } = useField(
  "check_day_" + (data.i.value + 1),
  (value: string) => value
);

const checkedFunctionValues = () =>
  data.values.value[
    ("check_day_" + (data.i.value + 1)) as keyof ChedulesDetails
  ] === "create" ||
  data.values.value[
    ("check_day_" + (data.i.value + 1)) as keyof ChedulesDetails
  ] === "init"
    ? true
    : false;

const checked = ref(!!data.shedules.value?.day || false);

const changeInputData = (target: HTMLInputElement) => {
  if (data.shedules.value?.day === data.i.value + 1) {
    resetField({
      value: target.checked ? "init" : "delete",
    });
  } else {
    resetField({
      value: target.checked ? "create" : "",
    });
  }
};

watch(
  () => data.values.value,
  () => {
    checked.value = checkedFunctionValues();
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      tabindex: _unref(data).tabindex.value,
      onChange: _cache[0] || (_cache[0] = ($event) => changeInputData($event.target as HTMLInputElement)),
      type: "checkbox",
      "input-value": _unref(value),
      name: 'check_day_' + (_ctx.i + 1),
      checked: checked.value
    }, null, 40, _hoisted_2),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(data).day.value), 1)
  ]))
}
}

})